import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import messageActions from 'actions/messages/actions';
import Threads from './threads'

const Messages = ({ match, getConversations, closeSubscriptions }) => {
  useEffect(() => {
    getConversations()
    return () => {
      closeSubscriptions()
    }
  }, [])
  return (
    <div className="messages flex flex-1">
      <Route
        path={`${match.path}`}
        component={Threads} />
    </div>
  );
};


Messages.propTypes = {
  match: PropTypes.object,
  getConversations: PropTypes.func,
  closeSubscriptions: PropTypes.func,
};

const mapDispatchToProps = {
  getConversations: messageActions.getConversations,
  closeSubscriptions: messageActions.closeSubscriptions,
};

export default withRouter(connect(null, mapDispatchToProps)(Messages));

